const SettingsContainer = ({ title, children, handleClose }: any) => {
  return (
    <div
      className="mt-4 lg:block max-lg:fixed max-lg:bottom-[50px] z-30 lg:w-2/5 max-lg:w-[96vw] max-lg:mx-[2vw]  lg:pl-[98px] lg:max-w-[520px] [height:calc(100%-45px)] max-lg:[height:30vh] max-sm:[height:35vh] md:relative lg:relative sm:absolute"
      // style={{ bottom: "175px" }}
    >
      <button className="absolute top-4 right-4" onClick={handleClose}>
        <svg
          width="12"
          height="13"
          viewBox="0 0 12 13"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.3955 11.1593C11.3955 11.6331 11.228 12.0375 10.8929 12.3726C10.5578 12.7077 10.1591 12.8752 9.69695 12.8752C9.16543 12.8752 8.74367 12.6903 8.4317 12.3206L5.84919 9.23546L3.26669 12.3206C2.95471 12.6903 2.53296 12.8752 2.00144 12.8752C1.53924 12.8752 1.1406 12.7077 0.805513 12.3726C0.470423 12.0375 0.302878 11.6331 0.302878 11.1593C0.302878 10.7318 0.441536 10.3621 0.718852 10.0501L3.63067 6.79161L0.926838 3.81047C0.649523 3.49849 0.510865 3.11718 0.510865 2.66654C0.510865 2.19279 0.67841 1.79415 1.0135 1.47062C1.36014 1.13553 1.76456 0.967983 2.22676 0.967983C2.76983 0.967983 3.21469 1.18752 3.56134 1.62661L5.84919 4.43443L8.13705 1.62661C8.48369 1.18752 8.92855 0.967983 9.47163 0.967983C9.93382 0.967983 10.3325 1.13553 10.6676 1.47062C11.0142 1.79415 11.1875 2.19279 11.1875 2.66654C11.1875 3.12873 11.1009 3.44649 10.9275 3.61981L8.06772 6.79161L10.9795 10.0501C11.2568 10.3621 11.3955 10.7318 11.3955 11.1593Z"
            fill="#CCCFD6"
          />
        </svg>
      </button>
      <div className="bg-white w-full  min-h-[75vh] rounded-lg shadow-header">
        <div className="bg-darknavy rounded-t-lg text-white font-bold text-center text-xl tracking-widest py-2">
          {title}
        </div>
        <div className="px-5 py-3 max-lg:overflow-y-auto max-lg:[height:calc(35vh-43px)] lg:pb-0">
          {children}
        </div>
      </div>
    </div>
  );
};

export default SettingsContainer;
